import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class extends Vue {
  @Prop({}) private idModal
  @Prop({}) private typeMenu
  @Prop({}) private titleModal
  @Prop({}) private deleteNotif
}
